<template>
    <div class="show-blocking-reason">
        <div v-if="['Threshold rule'].includes(reason)">
            <inline-svg
                src="/images/blocking_reason/threshold_rule.svg" aria-label="reason">
            </inline-svg>
            Threshold rule
        </div>
        <div v-else-if="['Proxy'].includes(reason)">
            <inline-svg
                src="/images/blocking_reason/proxy.svg" aria-label="reason">
            </inline-svg>
            Proxy and anonymizers
        </div>
        <div v-else-if="['Cross Campaign Blocking'].includes(reason)">
            <inline-svg
                src="/images/blocking_reason/cross_campaign.svg" aria-label="reason">
            </inline-svg>
            Cross Campaign Blocking
        </div>
        <div v-else data-toggle="tooltip" data-placement="bottom" title="Unknown">

        </div>
    </div>
</template>
<script>
    export default {
        props: ['reason'],
        mounted() {

        }
    }
</script>
